import { render, staticRenderFns } from "./AddProjectImage.vue?vue&type=template&id=0b9dcae1&scoped=true"
import script from "./AddProjectImage.vue?vue&type=script&lang=js"
export * from "./AddProjectImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9dcae1",
  null
  
)

export default component.exports